import React from "react";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { makeStyles } from "@material-ui/styles";

const useStyles = makeStyles({
  Fertility: {
    height: 40,
    "& .MuiSelect-select": {
      zIndex: "99",
      fontSize: "14px",
    },
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "#E6E6E6",
      backgroundColor: "#FFFFFF",
      borderRadius: "10px",
    },
    "& .MuiSelect-icon": {
      zIndex: "99",
    },
    "& .MuiButtonBase-root-MuiMenuItem-root": {
      WebkitAlignItems:'normal',
      alignItems: 'normal',
      backgroundColor:'red'
    },
    },
  });
function SelectMenuItem({ styles, option,name, value, onChange }) {
  const classes = useStyles();
  return (
    <FormControl className={styles}>
      <Select
        value={value}
        onChange={onChange}
        name={name}
        displayEmpty
        inputProps={{ "aria-label": "Without label" }}
        className={styles === "select-custom" ?  styles : classes.Fertility}
      >
        <MenuItem value={0}>Choose Reminder...</MenuItem>
        {option.map((a, i) => (
          <MenuItem value={a.value} key={i}>
            <span>
            {a.icon}&nbsp;
              {a.label}</span>
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}

export default React.memo(SelectMenuItem);
